const TOUR_LINK_KEYS = [
    'provider',
    'offer_id',
    'depart_id',
    'depart_name',
    'country_id',
    'country_name',
    'town_id',
    'town_name',
    'subregion_id',
    'hotel_id',
    'hotel_name',
    'hotel_image_src',
    'hotel_link',
    'hotel_adult',
    'hotel_child',
    'star_id',
    'star_name',
    'meal_id',
    'meal_name',
    'room_id',
    'room_name',
    'place_id',
    'place_name',
    'dt1',
    'dt2',
    'nights',
    'adult',
    'child',
    'ages',
    'oper_id',
    'oper_name',
    'price',
    'currency',
    'claim_mark',
    'credit',
    'CLAIM_MARK'
];

export default TOUR_LINK_KEYS;